// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__29f1l","title":"card_title__1xt6E","inActive":"card_inActive__oCGGc"};